// extracted by mini-css-extract-plugin
export default {"metier_container":"VMVMetier_metier_container__-D4--","bg":"VMVMetier_bg__ijK6E","headers_container":"VMVMetier_headers_container__xikCh","seprator":"VMVMetier_seprator__B7sG6"};